import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import solidity from '../assets/solidity.png';
import unifi from '../assets/unifi.png';

import python from '../assets/python.png';
import react from '../assets/react.png';


import circle from '../assets/circle.svg';
import LWV from '../assets/LWV.png';




export default {
  email,
  mobile,
  solidity,
  unifi,
  python,
  react,
  circle,
  LWV

};